import { render } from "./send-dialog.vue?vue&type=template&id=5f31a842&scoped=true&ts=true"
import script from "./send-dialog.vue?vue&type=script&lang=tsx"
export * from "./send-dialog.vue?vue&type=script&lang=tsx"

import "./send-dialog.vue?vue&type=style&index=0&id=5f31a842&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f31a842"]])

export default __exports__